export const AUTH_USER_QUERY_DATA_KEY = 'auth-user';
